var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.63518 11.681C7.93891 11.9848 8.43138 11.9848 8.73511 11.681L12.6239 7.7922C12.9277 7.48847 12.9277 6.996 12.6239 6.69227C12.3202 6.38853 11.8278 6.38853 11.5241 6.69227L8.96292 9.25339V2.31635C8.96292 1.8868 8.6147 1.53857 8.18515 1.53857C7.7556 1.53857 7.40737 1.8868 7.40737 2.31635V9.25339L4.84625 6.69227C4.54252 6.38853 4.05005 6.38853 3.74632 6.69227C3.44258 6.996 3.44258 7.48847 3.74632 7.7922L7.63518 11.681ZM3.77777 13.983C3.34822 13.983 3 14.3313 3 14.7608C3 15.1903 3.34822 15.5386 3.77777 15.5386H12.5925C13.0221 15.5386 13.3703 15.1903 13.3703 14.7608C13.3703 14.3313 13.0221 13.983 12.5925 13.983H3.77777Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e449981f.svg";
export { ForwardRef as ReactComponent };